/**
 * Badge "EN VIVO" (F3-G): se muestra cuando la sesión está dentro de su ventana
 * de acceso (mismo cálculo puro que el join, `joinWindowState`). Reutilizable en
 * las tarjetas de sesión del horario y de las tabs de cohorte.
 */
import { type Component, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { joinWindowState, type SessionTimes } from "@space/shared";
import { useI18n } from "@/providers/i18n-provider";
import { useNow } from "../hooks/use-now";

export const EnVivoBadge: Component<{ times: SessionTimes; class?: string }> = (props) => {
  const { t } = useI18n();
  const now = useNow();
  const live = () => joinWindowState(now(), props.times).isLiveNow;
  return (
    <Show when={live()}>
      <span
        class={`inline-flex items-center gap-1 rounded-full bg-danger/15 px-2 py-0.5 text-xs font-bold text-danger ${props.class ?? ""}`}
        data-testid="en-vivo-badge"
      >
        <span class="h-1.5 w-1.5 rounded-full bg-danger motion-safe:animate-pulse" />
        {t(msg`LIVE`)}
      </span>
    </Show>
  );
};
